import { useTranslation } from 'next-i18next/pages'
import { SwitchProductCtaProps } from './types'
import { Button } from '@boltenergy-be/design-system'

const SwitchProductCta = ({ openDrawer, paragraph }: SwitchProductCtaProps) => {
  const { t } = useTranslation('registration')

  return (
    <>
      {' '}
      {paragraph}
      <Button type="button" onClick={openDrawer} variant="inline">
        {t('billing.buttons.otherTariff')}
      </Button>
      .
    </>
  )
}

export default SwitchProductCta
